/**
 * Page Preloader Utility
 * Preloads page components and their critical resources
 */

// Cache for preloaded data
const preloadCache = new Map();

/**
 * Preload images for a specific page
 */
export const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    if (!preloadCache.has(url)) {
      const img = new Image();
      img.src = url;
      preloadCache.set(url, img);
    }
  });
};

/**
 * Preload all critical resources for main pages
 * Call this on app mount to preload everything
 */
export const preloadAllPages = () => {
  // Home page images
  const homeImages = [
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/logos/trading.svg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/moregraphics/whyus.png",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/moregraphics/vision.png",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/services/Construction-and-Maintenance.jpg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/services/Property-Management.jpg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/services/Renewable-Energy.jpg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/services/Cleaning-Services.jpg",
  ];

  // Financial page images
  const financialImages = [
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/logos/financial.svg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/moregraphics/didyouknow.png",
    "/accept.jpg",
  ];

  // Eats page images
  const eatsImages = [
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/logos/eats.svg",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/moregraphics/chef.png",
  ];

  // Brewers page images
  const brewersImages = [
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/logos/brewers.svg",
    "/gazebo.webp",
    "https://qvfnqibaomhtcplaixbr.supabase.co/storage/v1/object/public/web%20things/moregraphics/event.jpg",
  ];

  // Preload with delays to not block initial render
  setTimeout(() => preloadImages(homeImages), 500);
  setTimeout(() => preloadImages(financialImages), 1000);
  setTimeout(() => preloadImages(eatsImages), 1500);
  setTimeout(() => preloadImages(brewersImages), 2000);
};
